import { convertPriceToCents } from "utils/rewards";

export  const createFormData = (offer, isDisabled) => {

    const { coupons, redeem_limit, supply_limit, options, variants, deliverable, start_date, end_date, title, description, points, slug, content_text, content_email, min_amount, content_link, extended_description, category, new_promo_codes, existing_promo_codes, status, show_end_date, show_supply, visible, tag_ids, reward_ids, unit_price, currency, image_files, event_id} = offer;

    const existing_promo_codes_ids = existing_promo_codes && existing_promo_codes.map(item => item.id);    

    const formData = new FormData();
    const fields = [
        { key: 'title', value: title },
        { key: 'points', value: points ? points : 0 },
        { key: 'status', value: status },
        { key: 'show_end_date', value: show_end_date },
        { key: 'show_supply', value: show_supply },
        { key: 'visible', value: visible },
        { key: 'currency', value: currency },
        { key: "category", value: category },
        { key: "coupons", value: JSON.stringify(coupons) },
        { key: "tag_ids", value: JSON.stringify(tag_ids) },
        { key: "new_promo_codes", value: JSON.stringify(new_promo_codes) },
        { key: "existing_promo_codes", value: JSON.stringify(existing_promo_codes_ids) },
    ]
    
    if (min_amount) {
        fields.push({ key: "min_amount", value: min_amount });
    }

    if (start_date) {
        fields.push({ key: "start_date", value: start_date });
    }

    if (end_date) {
        fields.push({ key: "end_date", value: end_date });
    }

    if (description) {
        fields.push({ key: 'description', value: description });
    }

    if (extended_description) {
        fields.push({ key: 'extended_description', value: extended_description });
    }

    if (slug) {
        fields.push({ key: "slug", value: slug });
    }

    if (event_id) {
        fields.push({ key: 'event_id', value: event_id });
    }

    if (content_text) {
        fields.push({ key: 'text', value: content_text });
    }

    if (content_link) {
        fields.push({ key: 'link', value: content_link });
    }

    if (content_email) {
        fields.push({ key: 'email', value: content_email });
    }

    if (supply_limit) {
        fields.push({ key: 'supply_limit', value: supply_limit });
    }

    // SELL06 — options menu + sparse SKU rows for merch. Sent as JSON strings
    // (coupons pattern); blank values normalize (trimmed values, numeric stock).
    if (category === "merch") {
        const cleanOptions = (options || [])
            .map(axis => ({
                name: axis.name.trim(),
                values: (axis.values || []).map(value => value.trim()).filter(Boolean),
            }))
            .filter(axis => axis.name && axis.values.length > 0);
        const cleanVariants = (variants || []).map(variant => ({
            ...(variant.id && { id: variant.id }),
            options: variant.options,
            supply_limit: variant.supply_limit === '' || variant.supply_limit == null
                ? null
                : Number(variant.supply_limit),
            active: variant.active !== false,
        }));
        fields.push({ key: 'options', value: JSON.stringify(cleanOptions) });
        fields.push({ key: 'variants', value: JSON.stringify(cleanVariants) });
        fields.push({ key: 'deliverable', value: !!deliverable });
    }

    if (redeem_limit) {
        fields.push({ key: 'redeem_limit', value: redeem_limit });
    }

    if (unit_price) {
        fields.push({ key: 'price', value: convertPriceToCents(unit_price) });
    }

    if (!isDisabled){
        fields.push(
            { key: 'reward_ids', value: reward_ids },
        )
    }

    if (image_files && image_files.length > 0) {
        image_files.forEach((file) => {
            formData.append("images[]", file);
        });
    }

    fields.forEach(field => {
        formData.append(field.key, field.value);
    });

    return formData;
};
